import api from './api';

function authHeaders() {
	const token = localStorage.getItem('companyToken');
	return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function loginCompany(email, password) {
	const res = await api.post('/company/auth/login', { email, password });
	return res.data;
}

export async function registerCompany(data) {
	const res = await api.post('/company/auth/register', data);
	return res.data;
}

export async function getCompanyProfile() {
	const res = await api.get('/company/auth/profile', { headers: authHeaders() });
	return res.data;
}

export async function updateCompanyProfile(data) {
	const res = await api.put('/company/auth/profile', data, { headers: authHeaders() });
	return res.data;
}

export async function getCompanyStats() {
	// Placeholder endpoint; integrate when available
	return {
		totalJobs: 0,
		activeJobs: 0,
		totalApplications: 0,
		topMatch: { name: '', score: 0 }
	};
}


